//*colores de paleta #353535 -- gris cabecera//
import './App.css';
import Routes from './components/routes'
function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
